/*eslint-disable*/
const responses = {
  '2': 'success',
  '4': 'error',
  '5': 'error',
  200: 'OK',
  201: 'Created',
  204: 'No Content',
  400: 'Bad Request',
  401: 'Unauthorized',
  403: 'Forbidden',
  404: 'Not Found',
  405: 'Method Not Allowed',
  501: 'Not Implemented'
};

export default function checkResponse(status){
  const type = (status).toString()[0];
  return {
    type: responses[type],
    message: responses[status]
  }
}




// WEBPACK FOOTER //
// ./src/utils/ServerResponses.js